var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { staticClass: "sensor-form" },
        [
          _c(
            "page-title-area",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "right-floating-content",
                    fn: function () {
                      return [
                        !_vm.new_record
                          ? _c("counter", { attrs: { count: _vm.count } })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1478667609
              ),
            },
            [
              _vm.new_record
                ? _c("entity-header", { attrs: { icon: _vm.sensor.type } }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$mpt(_vm.$t("label.new_sensor"))) +
                        "\n    "
                    ),
                  ])
                : _c(
                    "entity-header",
                    {
                      attrs: {
                        details: _vm.featureIsActive("monitoring_point")
                          ? null
                          : _vm.sensor.place,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "icon",
                            fn: function () {
                              return [
                                _c("sensor-icon", {
                                  attrs: { sensorType: _vm.sensor.type },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2069893425
                      ),
                    },
                    [
                      _vm._v("\n      " + _vm._s(_vm.sensor.name) + "\n      "),
                      _vm.featureIsActive("monitoring_point")
                        ? _c("status-chip", {
                            staticClass: "ml-2",
                            attrs: { status: _vm.sensor.status },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sensor-form__content",
              attrs: { "data-testid": "SensorForm" },
            },
            [
              _c(
                "div",
                { staticClass: "sensor-form__form my-3" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("form-group", {
                        attrs: { required: _vm.state.editting },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$mpt(_vm.identifierLabel))
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("text-field", {
                                    staticClass: "sensor-form__form__id",
                                    attrs: {
                                      value: _vm.displayedSensorId,
                                      edit:
                                        _vm.state.editting && _vm.new_record,
                                      rules: _vm.rules.id,
                                      hint: _vm.identifierHint,
                                      errorMessages: _vm.state.idErrors,
                                      "data-testid": "sensor_identifier",
                                    },
                                    on: { input: _vm.updateId },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          582106615
                        ),
                      }),
                      _vm._v(" "),
                      _vm.capabilities.receives_mails && !_vm.new_record
                        ? _c("form-group", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("field.mail_address"))
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          attrs: {
                                            "data-testid":
                                              "sensor_mail_address",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.displayedMailAddress)
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2703298836
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form-group", {
                        attrs: { required: _vm.state.editting },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$mpt(_vm.$t("field.name")))
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("text-field", {
                                    attrs: {
                                      edit: _vm.state.editting,
                                      rules: _vm.rules.name,
                                      "data-testid": "sensor_name",
                                    },
                                    model: {
                                      value: _vm.model.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "name", $$v)
                                      },
                                      expression: "model.name",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          918632992
                        ),
                      }),
                      _vm._v(" "),
                      _vm.capabilities.hasPlace
                        ? _c("form-group", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.placeLabel)),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c("text-field", {
                                        attrs: {
                                          edit: _vm.state.editting,
                                          "data-testid": "sensor_place",
                                        },
                                        model: {
                                          value: _vm.model.place,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.model, "place", $$v)
                                          },
                                          expression: "model.place",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              267143092
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form-group", {
                        attrs: { required: _vm.state.editting },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("field.installation_date"))
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("date-field", {
                                    attrs: {
                                      edit: _vm.state.editting,
                                      rules: _vm.rules.installed_on,
                                      "data-testid": "sensor_installed_on",
                                    },
                                    model: {
                                      value: _vm.model.installed_on,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "installed_on", $$v)
                                      },
                                      expression: "model.installed_on",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1554887244
                        ),
                      }),
                      _vm._v(" "),
                      _vm.capabilities.threshold
                        ? _c("form-group", {
                            attrs: { required: _vm.state.editting },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("field.threshold"))
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c("text-field", {
                                        attrs: {
                                          type: "number",
                                          edit: _vm.state.editting,
                                          rules: _vm.rules.threshold,
                                        },
                                        model: {
                                          value: _vm.model.threshold,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "threshold",
                                              $$v
                                            )
                                          },
                                          expression: "model.threshold",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              708695631
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.capabilities.threshold
                        ? _c("form-group", {
                            attrs: { required: _vm.state.editting },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("field.increase_threshold")
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c("text-field", {
                                        attrs: {
                                          type: "number",
                                          edit: _vm.state.editting,
                                          rules: _vm.rules.increase_threshold,
                                        },
                                        model: {
                                          value: _vm.model.increase_threshold,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "increase_threshold",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "model.increase_threshold",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4267807892
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.capabilities.replacement
                        ? _c("form-group", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("field.trap_replaced_on")
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c("date-field", {
                                        attrs: {
                                          clearable: "",
                                          edit: _vm.state.editting,
                                        },
                                        model: {
                                          value: _vm.model.trap_replaced_on,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "trap_replaced_on",
                                              $$v
                                            )
                                          },
                                          expression: "model.trap_replaced_on",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              306862017
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.capabilities.replacement
                        ? _c("form-group", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("field.trap_effective_days")
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c("text-field", {
                                        attrs: {
                                          type: "number",
                                          edit: _vm.state.editting,
                                          rules: _vm.rules.trap_effective_days,
                                        },
                                        model: {
                                          value: _vm.model.trap_effective_days,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "trap_effective_days",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "model.trap_effective_days",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3643889997
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.capabilities.photoInterval
                        ? _c("form-group", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("field.photo_interval"))
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c("photo-interval-select-field", {
                                        attrs: { edit: _vm.state.editting },
                                        model: {
                                          value: _vm.model.photo_interval,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "photo_interval",
                                              $$v
                                            )
                                          },
                                          expression: "model.photo_interval",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2425874795
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form-group", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("field.memo"))),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("text-field", {
                                    attrs: {
                                      edit: _vm.state.editting,
                                      "data-testid": "sensor_memo",
                                    },
                                    model: {
                                      value: _vm.model.memo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "memo", $$v)
                                      },
                                      expression: "model.memo",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1618731486
                        ),
                      }),
                      _vm._v(" "),
                      !_vm.admin && _vm.capabilities.sendsNotifications
                        ? [
                            _vm.state.editting || _vm.shareable
                              ? _c("form-group", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("label.notifications")
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "input",
                                        fn: function () {
                                          return [
                                            _c("checkbox", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "notification.by_email"
                                                ),
                                                edit: _vm.state.editting,
                                              },
                                              model: {
                                                value: _vm.model.notice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "notice",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.notice",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3249351046
                                  ),
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.capabilities.health_check
                        ? _c("form-group", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("label.health_check"))
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        [
                                          _c("sensor-health-check-status", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              status:
                                                _vm.sensor.health_check_status,
                                              canDownload: _vm.admin,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mt-3",
                                              attrs: {
                                                justify: "start",
                                                "no-gutters": "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mr-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label.last_active"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatTimestamp(
                                                      _vm.sensor.last_active
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4067722732
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.new_record
                        ? _c("form-group", {
                            attrs: { "data-testid": "field_last-reception" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("label.last_reception"))
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _vm.sensor.last_event_request_time
                                        ? _c("sensor-last-reception", {
                                            attrs: {
                                              sensor: _vm.sensor,
                                              "shows-signal-strength":
                                                _vm.showsSignalStrength,
                                            },
                                          })
                                        : [
                                            _vm._v(
                                              _vm._s(_vm.$t("timestamp.none"))
                                            ),
                                          ],
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2414549481
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.new_record
                        ? _c("form-group", {
                            attrs: { "data-testid": "field_created-by" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("field.created_by"))
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "input",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.sensor.created_by.name || "--"
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2645204078
                            ),
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sensor-form__btn-group" },
                [
                  _vm.state.editting
                    ? [
                        _c(
                          "round-button",
                          {
                            staticClass:
                              "sensor-form__btn sensor-form__save my-3",
                            attrs: {
                              icon: "fa-check-circle",
                              fullWidth: "",
                              disabled:
                                _vm.state.checkingId || _vm.state.saving,
                              loading: _vm.state.saving,
                              "data-testid": "save",
                            },
                            on: { click: _vm.onSave },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("button.save")) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "round-button",
                          {
                            staticClass: "sensor-form__btn my-3",
                            attrs: {
                              icon: "fa-arrow-circle-left",
                              fullWidth: "",
                            },
                            on: { click: _vm.onCancel },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("button.cancel")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _vm.hasVideoDisplaySection
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "sensor-form__section sensor-form__section--video-display",
                                attrs: {
                                  "data-testid": "section-video-display",
                                },
                              },
                              [
                                _vm.capabilities.hasMedia
                                  ? _c(
                                      "round-button",
                                      {
                                        staticClass: "sensor-form__btn my-3",
                                        attrs: {
                                          icon: "fa-chevron-circle-down",
                                          fullWidth: "",
                                          to:
                                            "/activities?sensorId=" +
                                            _vm.sensor.id,
                                          "data-testid": "show-all",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t("button.show_all", {
                                                dataType: _vm.getTerm(
                                                  _vm.sensorDefinition.dataType,
                                                  { plural: true }
                                                ),
                                              })
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.uploadable
                                  ? _c(
                                      "upload-button",
                                      {
                                        attrs: {
                                          fullWidth: "",
                                          acceptedFiletypes:
                                            _vm.acceptedFiletypes,
                                          sensorId: _vm.sensor.id,
                                          "data-testid": "upload-button",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t("button.upload", {
                                                dataType: _vm.getTerm(
                                                  _vm.sensorDefinition.dataType
                                                ),
                                              })
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.editable && _vm.capabilities.shareable
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "sensor-form__section sensor-form__section--share",
                                attrs: { "data-testid": "section-share" },
                              },
                              [
                                _c("sensor-user-list", {
                                  attrs: {
                                    sensorId: _vm.sensor.id,
                                    shareable: !_vm.admin,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.editable &&
                        _vm.capabilities.shareable &&
                        _vm.hasAnyModifyAction
                          ? _c("v-divider", {
                              staticClass: "my-4",
                              attrs: { "data-testid": "divider-share-modify" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasAnyModifyAction
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "sensor-form__section sensor-form__section--modify",
                                attrs: { "data-testid": "section-modify" },
                              },
                              [
                                _vm.editable
                                  ? _c(
                                      "round-button",
                                      {
                                        staticClass:
                                          "sensor-form__btn sensor-form__edit my-3",
                                        attrs: {
                                          icon: "fa-pencil-square-o",
                                          fullWidth: "",
                                          "data-testid": "edit",
                                        },
                                        on: { click: _vm.onEdit },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("button.edit")) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.capabilities.receives_mails && _vm.editable
                                  ? _c(
                                      "round-button",
                                      {
                                        staticClass: "sensor-form__btn my-3",
                                        attrs: {
                                          icon: "fa-refresh",
                                          fullWidth: "",
                                          disabled: !_vm.mailRegeneratable,
                                          "data-testid": "generate-mail",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.confirmGenerateMail.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t("button.generate_mail")
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canShowRelocateButton
                                  ? _c(
                                      "round-button",
                                      {
                                        staticClass:
                                          "sensor-form__btn sensor-form__device-relocation my-3",
                                        attrs: {
                                          icon: "fa-arrow-right-arrow-left",
                                          fullWidth: "",
                                          "data-testid":
                                            "device-relocation-button",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.deviceRelocationDialog.visible = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t("button.relocate_device")
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.editable &&
                                _vm.featureIsActive("monitoring_point") &&
                                _vm.capabilities.canRelocate &&
                                _vm.sensor.status === "inactive" &&
                                !_vm.state.editting
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "round-button",
                                                        {
                                                          staticClass:
                                                            "sensor-form__btn sensor-form__device-relocation my-3",
                                                          attrs: {
                                                            icon: "fa-arrow-right-arrow-left",
                                                            fullWidth: "",
                                                            disabled: "",
                                                            "data-testid":
                                                              "device-relocation-button-disabled",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "button.relocate_device"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2513914482
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "device-relocation-hint",
                                            attrs: {
                                              "data-testid":
                                                "device-relocation-hint",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("msg.no_device_hint")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.editable
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          top: "",
                                          disabled: _vm.deletable,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "d-block",
                                                        },
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "round-button",
                                                        {
                                                          staticClass:
                                                            "sensor-form__btn my-3",
                                                          attrs: {
                                                            icon: "fa-trash-o",
                                                            fullWidth: "",
                                                            disabled:
                                                              !_vm.deletable,
                                                            "data-testid":
                                                              "delete-button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.confirmDelete,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "button.delete"
                                                                )
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2234752223
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "12px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.deleteDisabledSharedKey
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showConnectionLogsButton
                                  ? _c(
                                      "round-button",
                                      {
                                        staticClass: "sensor-form__btn my-3",
                                        attrs: {
                                          icon: "fa-list",
                                          fullWidth: "",
                                          to:
                                            "/admin/activity_logs/Sensor-" +
                                            _vm.sensor.id,
                                          "data-testid": "show-connection-logs",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t(
                                                "button.show_connection_logs"
                                              )
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c("confirm-dialog", {
            attrs: { message: _vm.confirmDialog.message },
            on: { yes: _vm.confirmDialog.onConfirm },
            model: {
              value: _vm.confirmDialog.visible,
              callback: function ($$v) {
                _vm.$set(_vm.confirmDialog, "visible", $$v)
              },
              expression: "confirmDialog.visible",
            },
          }),
          _vm._v(" "),
          _vm.featureIsActive("monitoring_point") &&
          _vm.capabilities.canRelocate
            ? _c("device-relocation-dialog", {
                attrs: {
                  loading: _vm.relocatingDevice,
                  "candidates-loading": _vm.loadingCandidates,
                  "destination-candidates": _vm.transferDestinationCandidates,
                  "source-name": _vm.sensor.name,
                  "source-device-id": _vm.sensor.device_id,
                },
                on: {
                  relocated: _vm.onRelocated,
                  transferred: _vm.onTransferDevice,
                  "inactive-mode-selected": _vm.onInactiveModeSelected,
                },
                model: {
                  value: _vm.deviceRelocationDialog.visible,
                  callback: function ($$v) {
                    _vm.$set(_vm.deviceRelocationDialog, "visible", $$v)
                  },
                  expression: "deviceRelocationDialog.visible",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }